// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.documents-container .info-head p {
  margin-bottom: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/components/Popups/BulkUploadErrorPopup/index.scss"],"names":[],"mappings":"AAEI;EACE,mBAAA;AADN","sourcesContent":[".documents-container {\n  .info-head {\n    p {\n      margin-bottom: 2rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
